import PasswordModal, { setCheckPasswordFunction, setCancelPasswordCheckCallback } from './PasswordModal';

export { setCheckPasswordFunction, setCancelPasswordCheckCallback };
export default PasswordModal;